<script setup>
const { $scrollTo } = useNuxtApp()
defineProps({
  top10WinesArray: {
    type: Array,
    required: true,
  },
})
const top10cards = ref(null)
const showTop10NextArrow = ref(true)
const selectedTop10Wine = ref(1)
function goToNextTop10Wine() {
  $scrollTo(`#top-10-${selectedTop10Wine.value + 1}`, 500, {
    container: '#top-10-cards',
    offset: 0,
    x: true,
    y: false,
  })
}
function goToPrevTop10Wine() {
  $scrollTo(`#top-10-${Math.max(1, selectedTop10Wine.value - 1)}`, 500, {
    container: '#top-10-cards',
    offset: 0,
    x: true,
    y: false,
  })
}
function updateTop10WineByScroll({
  target: { scrollLeft, scrollWidth, clientWidth },
}) {
  const firstWidth = top10cards.value.children[0].scrollWidth
  const nthWidth = top10cards.value.children[1].scrollWidth
  if (scrollLeft < firstWidth) {
    selectedTop10Wine.value = 1
  } else {
    selectedTop10Wine.value =
      Math.floor((scrollLeft - firstWidth) / nthWidth) + 2
  }
  showTop10NextArrow.value = scrollLeft + nthWidth < scrollWidth - clientWidth
}
</script>

<template>
  <section class="home-top10">
    <div class="top10">
      <h2 class="text-center">This Week&rsquo;s Member Favorites</h2>
      <button
        v-if="selectedTop10Wine > 1"
        class="prev"
        @click="goToPrevTop10Wine"
      >
        Prev
      </button>
      <button v-if="showTop10NextArrow" class="next" @click="goToNextTop10Wine">
        Next
      </button>
      <div
        id="top-10-cards"
        ref="top10cards"
        class="cards"
        @scroll="updateTop10WineByScroll"
      >
        <nuxt-link
          v-for="(wine, index) in top10WinesArray"
          :id="`top-10-${index + 1}`"
          :key="index + 1"
          :to="wine.url"
        >
          <div class="number">{{ index + 1 }}</div>
          <div class="img">
            <img
              :src="wine.bottle_image_url"
              alt=""
              class="lazyLoad isLoaded"
            />
            <div class="divider">&nbsp;</div>
          </div>
          <div class="winetagline">
            {{ wine.narrative_tag_line }}
            <div class="winename">{{ wine.title }}</div>
          </div>
        </nuxt-link>
      </div>
    </div>
  </section>
</template>
